// extracted by mini-css-extract-plugin
module.exports = {"imgcontainer":"linked_image_imgcontainer__3kutO","imgmagnifier":"linked_image_imgmagnifier__2Pkq1","images":"linked_image_images__2Wj4N"};